<template>
<div id="ajout_admin_port">
    <div class="vx-card">
        <div class="vx-card__header">
            <div class="vx-card__title">
                <h4 class>Nouveau Compte Admin</h4>
            </div>
        </div>
        <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body">
                <!-- Content Row -->
                <div class="vx-row w-full">

                    <div class="flex mb-4 vx-col md:w-full">

                        <div class="vx-col md:w-1/2 sm:w-1/1 w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Email</label>

                                <div class="mt-2">
                                    <vs-input v-model="admin.email" v-validate="'required'" class="w-full" icon-pack="feather" icon="icon-home" />

                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/2 sm:w-1/1 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Role</label>

                                <div class="mt-2">
                                    <v-select v-validate="'required'" label="designation" v-model="admin.role" :options="roles" name="role" />

                                </div>
                            </div>
                        </div>

                        <!-- Save & Reset Button -->

                    </div>

                    <div class="flex mb-4 vx-col md:w-full">

                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full bg-grid-color-secondary h-12 px-2">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Nom</label>

                                <div class="mt-2">
                                    <vs-input class="w-full" v-validate="'required'" v-model="admin.nom" icon-pack="feather" icon="icon-clock" />

                                </div>
                            </div>
                        </div>

                        <div class="vx-col md:w-1/2 sm:w-1/2 w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">
                                <label class="block text-gray-700 text-sm font-bold ">Prénom</label>

                                <div class="mt-2">
                                    <vs-input v-model="admin.prenom" class="w-full" v-validate="'required'" icon-pack="feather" icon="icon-home" />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="  flex mb-4 vx-col md:w-full ">

                        <div class="vx-col   w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">

                                <div class="mt-2 float-right">

                                    <vs-button @click="addCompte()">enregistrer</vs-button>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col  md:w-1/5 sm:w-full bg-grid-color-secondary  px-2 ">
                            <div class="w-full mt-1">

                                <div class="mt-2 float-right">
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import vSelect from "vue-select";
import adminServ from '@/http/requests/admin/index.js'
export default {
    components: {
        "v-select": vSelect
    },
    data() {
        return {
            admin: {
                nom: '',
                prenom: '',
                role: '',
                email: ''
            },
            roles: [{
                    id: 2,
                    designation: 'GestionnairePortail'
                },

            ],

        }
    },
    computed: {

    },
    mounted() {
        this.getListeRolesAdmin()
    },
    methods: {
        getListeRolesAdmin() {
          
            adminServ.getListeRolesAdmin().then(response => {
                this.roles = []
                console.log(response)
              response.data.forEach(element => {
                    this.roles.push({
                    id: element.id,
                    designation: element.designation
                })
         
              });
            })
        },
        addCompte() {
            console.log(this.admin)
            this.admin.role = this.admin.role.designation
            this.$vs.dialog({
                type: "confirm",
                color: "primary",
                title: `Ajout compte Admin`,
                text: "Voulez vous ajouter un nouveau compte",
                acceptText: "OUI",
                cancelText: "Annuler",
                accept: this.onaddCompte
            });

        },
        onaddCompte() {

            this.$vs.loading()
            adminServ.addAdminToPortail(this.admin).then(() => {
                this.$vs.loading.close()

                this.$swal.fire({
                    position: "absolute",
                    icon: "info",
                    title: "Ajout avec succés",
                    showConfirmButton: true,
                    timer: 2500
                });
                this.$router.push({
                    name: 'list_admin'
                })
            }).catch(error => {
                console.log(error.response)
                this.$vs.loading.close()
                this.$swal.fire({
                    position: "absolute",
                    icon: "warning",
                    title: "Erreur : " + error.response.data,
                    showConfirmButton: true,
                    timer: 2500
                });
            })
        },

    }
}
</script>

<style>

</style>
